import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/account/company/:companyId',
    name: 'route-account-my-company',
    component: () => import('@/views/apps/company/MyCompany.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MY_COMPANY,
      action: 'read',
      pageTitle: 'My Company',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'My Company',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/account/notifications',
    name: 'notifications',
    component: () => import('@/views/apps/account/notifications/Index.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_NOTIFICATIONS,
      action: 'read',
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/common/credentials/account',
    name: 'route-account-company-credentials',
    component: () => import('@/views/apps/company/credentials/Credentials.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_COMPANY_CREDENTIALS,
      action: 'read',
      pageTitle: 'Credentials',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Credentials',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/management/finance-tools',
    name: 'finance-tools',
    component: () => import('@/views/apps/finance/InvoicePreview.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVOICE_PREVIEW,
      action: 'read',
      pageTitle: 'Invoice Preview',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Invoice Preview',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/user-management/roles',
    name: 'route-management-roles-list',
    component: () => import('@/views/apps/permission/roles/roles-list/RolesList.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_ROLE_MANAGEMENT,
      action: 'read',
      pageTitle: 'Role Management',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Roles',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/apps/account/company/company-user-edit',
  //   name: 'apps-company-user-edit',
  //   component: () => import('@/views/apps/company/company-user-edit/CompanyUserEdit.vue'),
  //   meta: {
  //     resource: PERMISSIONS.RESOURCE_CLIENTS,
  //     action: 'read',
  //   },
  // },
  {
    path: '/apps/account/plan/my-plans',
    name: 'route-account-plans-my-plans',
    component: () => import('@/views/apps/plan-management/customer-plan/CustomerPlan.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MY_PLANS,
      action: 'read',
      pageTitle: 'My Plans',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'My Plans',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/account/plan/enrollment',
    name: 'route-account-plans-plan-enrollment',
    component: () => import('@/views/apps/plan-management/plans/PlanManagement.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MY_PLANS,
      action: 'read',
      pageTitle: 'Plan Enrollment',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'My Plans',
          to: '/apps/account/plan/my-plans',
        },
        {
          text: 'Plan Enrollment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/finance/invoices',
    name: 'accounting-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVOICE_LIST,
      action: 'read',
      pageTitle: 'Invoices',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Accounting',
        },
        {
          text: 'Invoices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/finance/transaction/:id',
    name: 'finance-transaction-void-refund',
    component: () => import('@/views/apps/finance/transaction/Index.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVOICE_LIST,
      action: 'read',
      pageTitle: 'Invoice & Transaction Details',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Accounting',
        },
        {
          text: 'Invoices',
          to: '/apps/finance/invoices',
        },
        {
          text: 'Invoice & Transaction Details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/account/merchant-connect',
    name: 'merchant-connect',
    component: () => import('@/views/apps/account/merchant-connect/Index.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MERCHANT_CONNECT,
      action: 'read',
      pageTitle: 'Merchant Connect',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Merchant Connect',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/finance/customer/charges',
    name: 'route-customer-charge',
    component: () => import('@/views/apps/finance/customer-charge/CustomerCharge.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_CUSTOMER_CHARGE,
      action: 'read',
      pageTitle: 'Charges',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Accounting',
        },
        {
          text: 'Charges',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/finance/customer/balances',
    name: 'route-customer-balance',
    component: () => import('@/views/apps/finance/balances/CustomerBalance.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SHIPPING_LABEL_FUNDS,
      action: 'read',
      pageTitle: 'Shipping Label Funds',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Accounting',
        },
        {
          text: 'Shipping Label Funds',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/invoice/detail/:id',
    name: 'apps-invoice-detail',
    component: () => import('@/views/apps/invoice/invoice-detail/InvoiceDetail.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVOICE_LIST,
      action: 'read',
    },
  },
  {
    path: '/apps/invoice/preview/:id',
    name: 'apps-invoice-preview',
    component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVOICE_LIST,
      action: 'read',
    },
  },
  {
    path: '/apps/user-management/role-permissions/:roleName/:roleId',
    name: 'route-management-role-permissions',
    component: () => import('@/views/apps/permission/roles/roles-permission/RoleSetup.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_ROLE_MANAGEMENT,
      action: 'read',
      pageTitle: 'Role Management',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Roles',
          to: '/apps/user-management/roles',
        },
        {
          text: 'Role Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/finance/cost-group',
    name: 'route-cost-group',
    component: () => import('@/views/apps/finance/cost-group/CostGroup.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_PREP_MATERIALS,
      action: 'read',
      pageTitle: 'Cost Group',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Prep Materials',
          to: '/apps/prep-materials/items',
        },
        {
          text: 'Cost Group',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/prep-materials/purchase',
    name: 'route-material-purchases',
    component: () => import('@/views/apps/prep-material/purchases/PrepMaterialPurchase.vue'),
    props: route => ({
      qPrepMaterialId: parseInt(route.query.qPrepMaterialId, 10) || null,
    }),
    meta: {
      resource: PERMISSIONS.RESOURCE_PREP_MATERIALS,
      action: 'read',
      pageTitle: 'Prep Material Purchases',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Prep Materials',
          to: '/apps/prep-materials/items',
        },
        {
          text: 'Prep Material Purchases',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/prep-materials/items',
    name: 'route-material-items',
    component: () => import('@/views/apps/prep-material/items/PrepMaterialItems.vue'),
    props: route => ({
      qCostGroupId: parseInt(route.query.qCostGroupId, 10) || null,
    }),
    meta: {
      resource: PERMISSIONS.RESOURCE_PREP_MATERIALS,
      action: 'read',
      pageTitle: 'Prep Materials & Services',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Prep Material Items',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/management/subscribe',
    name: 'route-notification-subscribe',
    component: () => import('@/views/apps/notification/Subscribe.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SUBSCRIPTIONS,
      action: 'read',
      pageTitle: 'Subscriptions',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Subscriptions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/settings/printer',
    name: 'printer-settings',
    component: () => import('@/views/apps/settings/PrinterSettings.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_PRINTER_SETTINGS,
      action: 'read',
      pageTitle: 'Printer Settings',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Account',
        },
        {
          text: 'Printer Settings',
          active: true,
        },
      ],
    },
  },
]
